// src/utils/relicVault/relicVaultService.js
//
// Persistence seam for the Relic Vault: owned relics, owned + equipped
// companions, and every QuikCoins spend or refund.
//
// ===========================================================================
// NOT YET BACKED BY THE DATABASE.
//
// Every function here is a stub that succeeds without a network call, so the
// whole store / vault / equip flow is testable today. When the endpoints exist,
// fill in these functions and nothing else in the app has to change.
//
// Suggested endpoints (from the designer's handoff):
//   fetchVaultState        GET  /api/vault
//                               -> { ownedRelicIds, ownedCompanionIds, equippedCompanionId }
//   purchaseRelic          POST /api/vault/relics/:id/purchase
//   purchaseCompanion      POST /api/vault/companions/:guildId/purchase
//   refreshStore           POST /api/vault/store/refresh
//   sellRelic              POST /api/vault/relics/:id/sell
//   saveEquippedCompanion  POST /api/vault/companions/equip   { guildId | "none" }
//
// Coins: while these are stubs nothing is debited server-side, so the store
// applies each spend/refund as a local adjustment on top of the real balance
// (store/relicVault `balanceAdjustment`). It resets on reload. Once an endpoint
// debits for real, return `newBalance` from it: the adjustment is dropped and
// the real balance is re-fetched instead.
//
// The server must own validation - ownership, affordability, and the
// twice-a-day refresh limit. The client-side checks are UX guards only.
// ===========================================================================

const stubSuccess = (name, payload) => {
  console.log(`[RelicVault][Service][${name}][Stub]`, payload);
  return { success: true };
};

/**
 * @param {string} userId
 * @returns {Promise<{ownedRelicIds: string[], ownedCompanionIds: string[], equippedCompanionId: string}|null>}
 *   null means "no stored state" - the store keeps its empty defaults.
 */
export async function fetchVaultState(userId) {
  console.log('[RelicVault][Service][FetchState][Stub]', { userId });
  // TODO(backend): GET /api/vault
  return null;
}

/**
 * @param {{userId: string, relicId: string, price: number}} params
 * @returns {Promise<{success: boolean, newBalance?: number, error?: string}>}
 */
export async function purchaseRelic(params) {
  // TODO(backend): POST /api/vault/relics/:id/purchase
  return stubSuccess('PurchaseRelic', params);
}

/**
 * @param {{userId: string, guildId: string, price: number}} params
 * @returns {Promise<{success: boolean, newBalance?: number, error?: string}>}
 */
export async function purchaseCompanion(params) {
  // TODO(backend): POST /api/vault/companions/:guildId/purchase
  return stubSuccess('PurchaseCompanion', params);
}

/**
 * @param {{userId: string, cost: number}} params
 * @returns {Promise<{success: boolean, newBalance?: number, error?: string}>}
 */
export async function refreshStore(params) {
  // TODO(backend): POST /api/vault/store/refresh - the server should own the
  // twice-a-day limit; the client date check is a convenience, not a boundary.
  return stubSuccess('RefreshStore', params);
}

/**
 * @param {{userId: string, relicId: string, refund: number}} params
 * @returns {Promise<{success: boolean, newBalance?: number, error?: string}>}
 */
export async function sellRelic(params) {
  // TODO(backend): POST /api/vault/relics/:id/sell
  return stubSuccess('SellRelic', params);
}

/**
 * @param {{userId: string, guildId: string}} params  guildId, or "none"
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function saveEquippedCompanion(params) {
  // TODO(backend): POST /api/vault/companions/equip. Unity also mirrors the
  // equipped guardian into PlayerPrefs, so one device remembers it already.
  return stubSuccess('SaveEquippedCompanion', params);
}
